import { IAppState } from '../appState';
import { StateV12 } from './12_migrate_kooperations_nachlass.interface';

export const migrateKooperationsNachlass = (
  previousState: StateV12,
  newVersion: number,
  currentState: IAppState,
): StateV12 => {
  const foundKooperation = currentState.transientState.kooperationen?.some(
    k => k?.code === previousState.vertragsoptionen?.selectedKooperation,
  );

  if (!foundKooperation) {
    delete previousState.vertragsoptionen?.selectedKooperation;
  }

  return {
    ...previousState,
    version: newVersion,
  };
};
